export default function normalizeText(text) {
  return text.trim().replace(/[\r\n\u200B]/g, '');
}
